export const ADD_PLAYLIST_REQUEST = "ADD_PLAYLIST_REQUEST";
export const ADD_PLAYLIST_SUCCESS = "ADD_PLAYLIST_SUCCESS";
export const ADD_PLAYLIST_ERROR = "ADD_PLAYLIST_ERROR";
export const ADD_PLAYLIST_DONE = "ADD_PLAYLIST_DONE";

export const addPlaylistRequest = (payload) => ({
  type: ADD_PLAYLIST_REQUEST,
  ...payload,
});

export const addPlaylistSuccess = (playlist) => ({
  type: ADD_PLAYLIST_SUCCESS,
  playlist,
});

export const addPlaylistError = () => ({
  type: ADD_PLAYLIST_ERROR,
});

export const addPlaylistDone = () => ({
  type: ADD_PLAYLIST_DONE,
});



// WEBPACK FOOTER //
// ./src/pages/playlists/add/actions.js